// Lightweight WebRTC peer connection helper.
const ICE_SERVERS = [
  { urls: "stun:stun.l.google.com:19302" },
  { urls: "stun:stun1.l.google.com:19302" },
];

export function createPeer({ stream, onTrack, onIce }) {
  const pc = new RTCPeerConnection({ iceServers: ICE_SERVERS });
  if (stream) {
    stream.getTracks().forEach((t) => pc.addTrack(t, stream));
  }
  pc.onicecandidate = (e) => {
    if (e.candidate) onIce(e.candidate.toJSON());
  };
  pc.ontrack = (e) => onTrack(e.streams[0] || new MediaStream([e.track]));
  return pc;
}

export function openSignal({ meetingId, userId, role, onMessage }) {
  const proto = window.location.protocol === "https:" ? "wss" : "ws";
  // Backend WS is exposed at /api/ws/signal/<meeting_id>
  const backend = process.env.REACT_APP_BACKEND_URL || `${window.location.origin}`;
  const host = backend.replace(/^https?:\/\//, "");
  const url = `${proto}://${host}/api/ws/signal/${meetingId}?user_id=${encodeURIComponent(userId)}&role=${encodeURIComponent(role)}`;
  const ws = new WebSocket(url);
  ws.onmessage = (e) => {
    try {
      onMessage(JSON.parse(e.data));
    } catch (err) {
      console.warn("Bad ws msg", err);
    }
  };
  return ws;
}
